<div class="user-home-container " id="main-view" #viewDOM>
    <div class="sidebar-warapper" (click)="closeDropdown()">
        <div class="sidebar">
            <div class="brand-name" style="border-bottom:1px solid #aaaaaa; padding-bottom: 17px;">
                <img class="large" src="/assets/brand-logo.png">
                <img class="small" src="/assets/brand-logo.png">
            </div>
            <div class="brand-name"></div>
            <div class="nav-list">
                <div class="item spacer"></div>
                <div class="item" *ngFor="let item of navList" [class.active]="item.route === activeSection">
                    
                    <!-- Dashboard (conditionally hidden) -->
                    <div class="item-main"
                        *ngIf="(availableFeatures.OneTrack != false &&
                                  (availableFeatures.oneTrackAdvanced != false ||
                                   availableFeatures.oneDesignOneClone != false ||
                                   availableFeatures.oneDesignOneSync != false)) &&
                               item.name == 'Dashboard'"
                        [class.active]="item.route === activePage || (item.route === activeSection && !item.children)" 
                        (click)="onclick1()" [class.disabled]="disableUser">
                        <div [routerLink]="'/home/'+item.route" style="align-items: center; display: flex;align-items: center;">
                            <img class="def "  src="assets/icons/nav-bar/dashboardWhite.svg">
                            <img class="focus "  src="assets/icons/nav-bar/dashboard-light.svg">
                            <span class="label">{{ item.name }}</span>
                        </div>
                        <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu(item.route)">
                    </div>

                    <!-- OneTrack Lite -->
                    <div class="item-main" *ngIf="availableFeatures.OneTrack!=false && item.name=='OneTrack Lite' && item.name !== 'Dashboard'" 
                        [class.active]="item.route === activePage || (item.route === activeSection && !item.children)" (click)="onclick1()"  [class.disabled]="disableUser">
                        <div [routerLink]="'/home/'+item.route" style="align-items: center; display: flex;align-items: center;">
                            <img class="def "  src="assets/icons/Onetrack.svg">
                            <img class="focus "  src="assets/icons/onetrackwhite.svg">
                            <span class="label">{{ item.name }}</span>
                        </div>
                        <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu(item.route)" [class.disabled]="disableUser">
                        
                         
                    </div>
                <div class="item-main" *ngIf="availableFeatures.oneTrackAdvanced!=false && item.name=='OneTrack Advanced'" 
                    [class.active]="item.route === activePage || (item.route === activeSection && !item.children)" (click)="onclick1()" [class.disabled]="disableUser">
                   <div [routerLink]="'/home/'+item.route" style="align-items: center; display: flex;align-items: center;">
                    <img class="def"  src="assets/icons/OnetrackAdvance.svg">
                    <img class="focus"  src="assets/icons/onetrackadvanceWhite.svg">
                    <span class="label">{{ item.name }}</span>
                </div>
                    <img class="def"  style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu(item.route)" [class.disabled]="disableUser">
                   
                </div>
                <div class="item-main" *ngIf="item.name=='Select Query' && this.isPlatformAdmin==true"
                    [class.active]="activePage === 'select-query-run'" (click)="onclick1()" [class.disabled]="disableUser">
                    <div [routerLink]="'/home/admin-pannel/select-query-run'" style="align-items: center; display: flex;align-items: center;">
                        <img class="def "  src="assets/icons/nav-bar/dashboardWhite.svg">
                        <img class="focus "  src="assets/icons/nav-bar/dashboard-light.svg">
                        <span class="label">{{ item.name }}</span>
                    </div>
                    <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu('admin-pannel/select-query-run')">
                </div>
                <div class="item-main" *ngIf="item.name=='User Management' && this.isPlatformAdmin==true"
                    [class.active]="activePage === 'user-management'" (click)="onclick1()" [class.disabled]="disableUser">
                    <div [routerLink]="'/home/admin-pannel/user-management'" style="align-items: center; display: flex;align-items: center;">
                        <img class="def "  src="assets/icons/nav-bar/dashboardWhite.svg">
                        <img class="focus "  src="assets/icons/nav-bar/dashboard-light.svg">
                        <span class="label">{{ item.name }}</span>
                    </div>
                    <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu('admin-pannel/user-management')">
                </div>
                <div class="item-main" *ngIf="item.name=='Clear Stuck Flow' && this.isPlatformAdmin==true"
                    [class.active]="activePage === 'clear-stuck-flow'" (click)="onclick1()" [class.disabled]="disableUser">
                    <div [routerLink]="'/home/admin-pannel/clear-stuck-flow'" style="align-items: center; display: flex;align-items: center;">
                        <img class="def "  src="assets/icons/nav-bar/dashboardWhite.svg">
                        <img class="focus "  src="assets/icons/nav-bar/dashboard-light.svg">
                        <span class="label">{{ item.name }}</span>
                    </div>
                    <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu('admin-pannel/clear-stuck-flow')">
                </div>
                <div class="item-main" *ngIf="item.name=='Read File' && this.isPlatformAdmin==true"
                    [class.active]="activePage === 'read-file'" (click)="onclick1()" [class.disabled]="disableUser">
                    <div [routerLink]="'/home/admin-pannel/read-file'" style="align-items: center; display: flex;align-items: center;">
                        <img class="def "  src="assets/icons/nav-bar/dashboardWhite.svg">
                        <img class="focus "  src="assets/icons/nav-bar/dashboard-light.svg">
                        <span class="label">{{ item.name }}</span>
                    </div>
                    <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu('admin-pannel/read-file')">
                </div>
                <div class="item-main" *ngIf="item.name=='All Org Details' && this.isPlatformAdmin==true"
                    [class.active]="activePage === 'all-org-details'" (click)="onclick1()" [class.disabled]="disableUser">
                    <div [routerLink]="'/home/admin-pannel/all-org-details'" style="align-items: center; display: flex;align-items: center;">
                        <img class="def "  src="assets/icons/nav-bar/dashboardWhite.svg">
                        <img class="focus "  src="assets/icons/nav-bar/dashboard-light.svg">
                        <span class="label">{{ item.name }}</span>
                    </div>
                    <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu('admin-pannel/all-org-details')">
                </div>
                <div class="item-main" *ngIf="item.name=='Genesys AWS Regions' && this.isPlatformAdmin==true"
                    [class.active]="activePage === 'genesys-aws-regions'" (click)="onclick1()" [class.disabled]="disableUser">
                    <div [routerLink]="'/home/admin-pannel/genesys-aws-regions'" style="align-items: center; display: flex;align-items: center;">
                        <img class="def "  src="assets/icons/nav-bar/dashboardWhite.svg">
                        <img class="focus "  src="assets/icons/nav-bar/dashboard-light.svg">
                        <span class="label">{{ item.name }}</span>
                    </div>
                    <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu('admin-pannel/genesys-aws-regions')">
                </div>
                 <div class="item-main" *ngIf="availableFeatures.oneChange!=false && item.name=='OneChange'" 
                    [class.active]="item.route === activePage" [class.disabled]="disableUser">
                    <div [routerLink]="'/home/'+item.route" style="align-items: center; display: flex;align-items: center;" (click)="onclick()" [class.disabled]="disableUser">
                        <img class="def"  src="assets/icons/Onechange2.svg" >
                        <img class="focus"  src="assets/icons/onechangeWhite.svg" >
                        <span class="label">{{ item.name }}</span>
                        
                    </div>
                  
                    <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu(item.route)">
                  
                </div>
                <div class="item-main" *ngIf="(availableFeatures.oneDesignOneClone!=false||availableFeatures.oneDesignOneSync!=false) && item.name=='OneDesign'" 
                [class.active]="item.route === activePage" [class.disabled]="disableUser" >
                <div [routerLink]="'/home/'+item.route" style="align-items: center; display: flex;align-items: center;" (click)="oneDesignlick()">
                    <img class="def"  src="assets/icons/Onechange2.svg" >
                    <img class="focus"  src="assets/icons/onechangeWhite.svg" >
                    <span class="label">{{ item.name }}</span>
                    
                </div>
              
                <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu(item.route)">
              
            </div>
                <div>
               
                <div class="sub-menu bewel" *ngIf="item.children && item.name=='OneChange'" [class.disabled]="disableUser"
                >
                    <ng-container *ngFor="let sub of item.children">
                        <div *ngIf="visible" class="item-sub bewel" style="align-items: center; display: flex;align-items: center;"
                            
                            [class.active]="sub.route === activePage"  >
                          
                            <div style="align-items: center; display: flex;align-items: center;" [routerLink]="'/home/'+item.route+'/'+sub.route">
                                <img class="def " *ngIf="sub.name=='Package Group'" src="assets/icons/packageGroup.svg" >
                                <img class="focus" *ngIf="sub.name=='Package Group'" src="assets/icons/packagegroupwhite.svg" >
                                <img class="def" *ngIf="sub.name=='Package Report'" src="assets/icons/reportnew.svg" >
                                <img class="focus" *ngIf="sub.name=='Package Report'" src="assets/icons/reportwhite.svg" >
                                <img class="def" *ngIf="sub.name=='Flow Promote'" src="assets/icons/flowpromote.svg">
                                <img class=" focus" *ngIf="sub.name=='Flow Promote'" src="assets/icons/flowpromotewhite.svg">
                                <img class="def" *ngIf="sub.name=='Compare & Sync'" src="assets/icons/entitycompare.svg">
                                <img class="focus" *ngIf="sub.name=='Compare & Sync'" src="assets/icons/entitycomparewhite.svg">
                                <!-- <img class="def" *ngIf="sub.name=='Compare Object'" src="assets/icons/dashboard.svg">
                                <img class="focus" *ngIf="sub.name=='Compare Object'" src="assets/icons/dashboard-light.svg"> -->
                             <span class="label" id="subname">{{ sub.name }}</span>
                            </div>
                            
                             <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu1(sub.route)">
                            
                        </div>
                    </ng-container>
                    <div class="bewel"></div>
                </div>
               <!-- OneDesign submenu -->
               <div class="sub-menu bewel" *ngIf="item.children && item.name=='OneDesign'" [class.disabled]="disableUser">
                <ng-container *ngFor="let sub of item.children">
                  <!-- Level 1: OneClone / OneSync -->
                  <div *ngIf="OneDesignVisible"
                    class="item-sub bewel"
                    [class.active]="sub.route === activePage"
                    style="display: flex; align-items: center;"
                  >
                    <div  [routerLink]="'/home/'+item.route+'/'+sub.route"
                      style="display: flex; align-items: center; cursor: pointer;"
                      (click)="toggleOneDesignSub(sub.route)"
                    >
                      <img class="def" *ngIf="sub.name=='OneClone'" src="assets/icons/oneclone.svg">
                      <img class="focus" *ngIf="sub.name=='OneClone'" src="assets/icons/oneclonewhite.svg">
                      <img class="def" *ngIf="sub.name=='OneSync'" src="assets/icons/onesync.svg">
                      <img class="focus" *ngIf="sub.name=='OneSync'" src="assets/icons/onesyncwhite.svg">
                      <span class="label">{{ sub.name }}</span>
                    </div>
             
                    <img
                      class="def"
                      style="padding-left:10px; display: inline-block;"
                      src="assets/icons/externalWhite.svg"
                      (click)="selectMenu2(sub.route)"
                      [routerLink]="'/home/'+item.route+'/'+sub.route"
                    />
                  </div>
             
                  <!-- Level 2: OneClone children (like OneClone Report) -->
                  <div
                    *ngIf="oneDesignExpandedItem === sub.route && sub.children"
                    class="sub-menu bewel"
                    style="margin-left: 20px;"
                  >
                    <ng-container *ngFor="let subchild of sub.children">
                      <div *ngIf="OneDesignVisible"
                        class="item-sub bewel"
                        style="display: flex; align-items: center;"
                        [class.active]="subchild.route === activePage"
                      >
                        <div
                          style="display: flex; align-items: center; cursor: pointer;"
                          [routerLink]="'/home/'+item.route+'/'+sub.route+'/'+subchild.route"
                            
                        >
                          <span class="label">{{ subchild.name }}</span>
                        </div>
             
                        <img
                          class="def"
                          style="padding-left:10px; display: inline-block;"
                          src="assets/icons/externalWhite.svg"
                          (click)="selectMenu2(subchild.route)"
                        />
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>

                </div>
                <!-- OneBusiness -->
                <div class="item-main" *ngIf="availableFeatures.oneDesignOneClone==true && availableFeatures.oneDesignOneSync==true && item.name=='OneBusiness'"
                    [class.active]="item.route === activeSection || oneBusinessVisible"
                    [class.disabled]="disableUser">
                    <div style="align-items: center; display: flex;align-items: center; cursor: pointer;" (click)="oneBusinesslick(); $event.stopPropagation()">
                        <img class="def"  src="assets/icons/Onechange2.svg">
                        <img class="focus"  src="assets/icons/onechangeWhite.svg">
                        <span class="label">{{ item.name }}</span>
                    </div>
                    <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu(item.route)">
                </div>
                <!-- OneBusiness submenu -->
                <div class="sub-menu bewel" *ngIf="item.children && item.name=='OneBusiness' && availableFeatures.oneDesignOneClone==true && availableFeatures.oneDesignOneSync==true" [class.disabled]="disableUser">
                    <ng-container *ngFor="let sub of item.children">
                        <div *ngIf="oneBusinessVisible"
                            class="item-sub bewel"
                            style="display: flex; align-items: center;"
                            [class.active]="sub.route === activePage">
                            <div [routerLink]="'/home/one-business/'+sub.route"
                                style="display: flex; align-items: center; cursor: pointer;"
                                (click)="onclick1()">
                                <img class="def"  src="assets/icons/Onechange2.svg">
                                <img class="focus" src="assets/icons/onechangeWhite.svg">
                                <span class="label">{{ sub.name }}</span>
                            </div>
                            <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu3(sub.route)">
                        </div>
                    </ng-container>
                </div>
                  <div class="item-main" *ngIf="availableFeatures.oneChange!=false && item.name=='Reports'" 
                    [class.active]="item.route === activePage" [class.disabled]="disableUser">
                    <div [routerLink]="'/home/'+item.route" style="align-items: center; display: flex;align-items: center;" (click)="Reportlick()">
                        <img class="def "  src="assets/icons/nav-bar/reportsOnecg.svg">
                            <img class="focus "  src="assets/icons/nav-bar/reports-light.svg">
                        <span class="label">{{ item.name }}</span>
                        
                    </div>
                  
                    <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu(item.route)">
                  
                </div>
                <div class="sub-menu bewel" *ngIf="item.children && item.name=='Reports'"
               [class.disabled]="disableUser" >
                    <ng-container *ngFor="let sub of item.children" [class.disabled]="disableUser">
                        <div *ngIf="this.reportvisible"  class="item-sub bewel" style="align-items: center; display: flex;align-items: center;"
                            
                            [class.active]="sub.route === activePage"  >
                          
                            <div style="align-items: center; display: flex;align-items: center;" [routerLink]="'/home/'+item.route+'/'+sub.route">
                                <img class="def" *ngIf="sub.name=='Package Report'" src="assets/icons/packagereport.svg">
                                <img class="focus" *ngIf="sub.name=='Package Report'" src="assets/icons/packagereportwhite.svg">
                                <img class="def" *ngIf="sub.name=='Flow Promote Report'" src="assets/icons/flowpromotereport.svg">
                                <img class="focus" *ngIf="sub.name=='Flow Promote Report'" src="assets/icons/flowpromotereportwhite.svg">
                                <img class="def" *ngIf="sub.name=='OneClone Report'" src="assets/icons/oneclonereport.svg">
                                <img class="focus" *ngIf="sub.name=='OneClone Report'" src="assets/icons/oneclonereportwhite.svg">
                                <img class="def" *ngIf="sub.name=='Provisioning History'" src="assets/icons/flowpromotereport.svg">
                                <img class="focus" *ngIf="sub.name=='Provisioning History'" src="assets/icons/flowpromotereportwhite.svg">
                             <span class="label" id="subname">{{ sub.name }}</span>
                            </div>
                            
                             <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg" (click)="selectMenu1(sub.route)">
                            
                        </div>
                    </ng-container>
                    <div class="bewel"></div>
                </div>
                  <!-- <div class="sub-menu bewel" *ngIf="item.name=='Backup'"
               [class.disabled]="disableUser" >
                    <ng-container [class.disabled]="disableUser">
                        <div   class="item-main" style="align-items: center; display: flex;align-items: center;" [routerLink]="'/home/'+item.route"  [class.active]="item.route === activePage || (item.route === activeSection && !item.children)">
                           <img class="focus "  src="assets/icons/nav-bar/help.svg">
                            <img class="def "  src="assets/icons/nav-bar/colorhelp.svg">
                           <span class="label" id="subname" >{{ item.name }}</span>
                                                        <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg">
                        </div>
                    </ng-container>
                    <div class="bewel"></div>
                </div> -->
                  <div class="sub-menu bewel" *ngIf="item.name=='Help'"
               [class.disabled]="disableUser" >
                    <ng-container [class.disabled]="disableUser">
                        <div   class="item-main" style="align-items: center; display: flex;align-items: center;">
                           <img class="focus "  src="assets/icons/nav-bar/help.svg">
                            <img class="def "  src="assets/icons/nav-bar/colorhelp.svg">
                           <span class="label" id="subname" (click)="UserGuide()">{{ item.name }}</span>
                                                        <img class="def" style="padding-left:10px;display: inline-block;" src="assets/icons/externalWhite.svg">
                        </div>
                    </ng-container>
                    <div class="bewel"></div>
                </div>
                    <ng-container *ngIf="!item.children">
                        <div class="bewel"></div>
                    </ng-container>
                </div>
                <div class="item spacer"></div>
            </div>
            <div class="build-version" *ngIf="isPlatformAdmin">
                <div class="build-title">OneCG Build Info:</div>
                <div class="build-value">Version: <span>{{ buildVersionLabel || '-' }}</span></div>
                <div class="build-date">Date &amp; Time: <span>{{ buildVersionDateTime || '-' }}</span></div>
            </div>
        </div>
    </div>
    <div class="body-container"  *ngIf="!loadingFeatures && user">
        <div class="view-wrapper" >
            <div class="user-main-panel" id="menuHeaderpanel" style="background-color: none;">
                 <div class="menu-trigger" style="margin-left: 30px;" (click)="toggleSidePanel()"><img src="assets/icons/open-menu-oneCG.svg" >

                                </div>
                <div class="user-actions">
                    <div class="user-profile" [class.active]="showUserMenu" >
                        <div class="dropdown-trigger" (click)="userMenuToggler()">
                            <div class="thumb" style="display: flex; gap: 10px;">
                                <img  src="/assets/dummy-profile-pic.jpg" style="width: 40px;height: 40px;border-radius: 50%;">
                                <div class="label" style="color: #1a3098;margin-top: 5px;" >{{user?.name}} {{user?.middle_name}}</div>
                              </div>
                        </div>
                        <div class="user-nav-list" *ngIf="showUserMenu" style="position: relative;z-index: 1;background-color: white;border-bottom-left-radius: 30px;border-bottom-right-radius: 30px;">
                            <!--Hari Sir told me to remove thos uninstall on 15/02/24 -->
                            <!-- <div (click)="uninstall()">Uninstall</div> --> 
                            <div (click) = "navTo('/home/profile-section')"> Profile</div>
                            <div (click) = "navTo('/home/user-mangement')" *ngIf="this.isPlatformAdmin!=true" [class.disabled]="disableUser"> Environment Details</div>
                            <div (click) = "navTo('/home/environment-mapping')" *ngIf="this.isPlatformAdmin!=true" [class.disabled]="disableUser"> Environment Mapping</div>
                            <div (click) = "navTo('/home/git-details')" *ngIf="this.availableFeatures.oneChange==true||
                             this.availableFeatures.oneDesignOneClone==true ||this.availableFeatures.oneDesignOneSync==true" [class.disabled]="disableUser"> GIT Details</div>
                             <div (click) = "navTo('/home/token-generation')" *ngIf="this.availableFeatures.oneChange==true||
                             this.availableFeatures.oneDesignOneClone==true ||this.availableFeatures.oneDesignOneSync==true" [class.disabled]="disableUser"> Generate Token</div>         
                            <div (click) = "navTo('/home/user-management-section')" *ngIf="this.showManagement==true && this.isPlatformAdmin!=true" [class.disabled]="disableUser"> User Management</div>
                             <div (click) = "navTo('/home/dynamicFileList')" *ngIf="this.showManagement==true && this.isPlatformAdmin!=true" [class.disabled]="disableUser"> Upload Files</div>
                               <div (click) = "navTo('/home/template-list')" *ngIf="this.showManagement==true && this.isPlatformAdmin!=true" [class.disabled]="disableUser"> Templates</div>
                               <div (click) = "navTo('/home/configurations')" *ngIf="this.showManagement==true" [class.disabled]="disableUser"> Configurations</div>
                               <div (click) = "navTo('/home/environment-patterns')" *ngIf="this.showManagement==true" [class.disabled]="disableUser"> Environment Patterns</div>
                            <div class="red" (click)="logout()">Logout</div>
                        </div>
                    </div>

                </div>
            </div>
            
            <div id="allMainPage" *ngIf="settingWidth" style="width: 80%;" (click)="closeDropdown()">
                 <router-outlet></router-outlet>
            </div>
            <div id="allMainPage" *ngIf="!settingWidth" style="width: 100%;" (click)="closeDropdown()">
                <router-outlet></router-outlet>
           </div>
            <div id="mySidenav" class="Notificationnav">
                <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
                <iframe src="https://quicktest.ai/getstarted/" name="targetframe" allowTransparency="true" scrolling="yes" frameborder="0"  height="100%">
                  </iframe>
              </div>
        </div>
        
    </div>
</div>
